import { Component, Inject, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-case-studies',
  templateUrl: './case-studies.component.html',
  styleUrls: ['./case-studies.component.css']
})
export class CaseStudiesComponent {
  baseUrl = Constants.baseUrl;
  constructor(
    private titleService: Title,
    private metaService: Meta, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  private seoService: SeoService
  ) {}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
 {
      "@context": "https://schema.org",
      "@type": "Article",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://mitresource.com/case-studies/"
      },
      "headline": "Case Studies - Technology Consulting and IT services | Maganti IT",
      "description": "Learn how Maganti IT partnered with a manufacturing client to build a resilient and future-ready, strategy-driven cloud infrastructure.",
      "image": "https://mitresource.com/assets/images/casestudies/casestudy-curorc.png",  
      "author": {
        "@type": "Organization",
        "name": "Maganti IT",
        "url": "https://mitresource.com/"
      },  
      "publisher": {
        "@type": "Organization",
        "name": "Maganti IT",
        "logo": {
          "@type": "ImageObject",
          "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
        }
      },
      "datePublished": "2024-10-28"
    }`;
   
    this._renderer2.appendChild(this._document.head, script);
   this.seoService.createLinkForCanonicalURL();   
    this.setTitleAndMetaTags();
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Case Studies - Technology Consulting and IT services | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'We are a professional IT services provider with years of experience working with organizations in the financial services and banking sectors. Contact us!' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ]);
  }
}
